import Vue from 'vue'
import VueRouter from 'vue-router'
import { getSiteBasePath } from '@/utils/site'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../components/JpHome.vue')
  },
  {
    path: '/company-profile',
    name: 'CompanyProfile',
    component: () => import(/* webpackChunkName: "company-profile" */ '../components/JpCompanyProfile.vue')
  },
  {
    path: '/feature-intro',
    name: 'FeatureIntro',
    component: () => import(/* webpackChunkName: "feature-intro" */ '../components/JpFeatureIntro.vue')
  },
  {
    path: '/news-center',
    name: 'NewsCenter',
    component: () => import(/* webpackChunkName: "news-center" */ '../components/JpNewsCenter.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import(/* webpackChunkName: "news-detail" */ '../components/JpNewsDetail.vue')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import(/* webpackChunkName: "download" */ '../components/JpDownload.vue')
  },
  {
    path: '/download-guide',
    name: 'DownloadGuide',
    component: () => import(/* webpackChunkName: "download-guide" */ '../components/WechatDownloadGuide.vue'),
    meta: {
      hideSiteChrome: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: getSiteBasePath(),
  routes
})

export default router
